import { Box, styled, Typography } from "@tm/components"
import { ElementType, PropsWithChildren } from "react"
import { Link } from "react-router-dom"

export type TextLinkProps = PropsWithChildren<{
    size?: "l"
    to?: string
    onClick: () => void
    component: ElementType
}>

const StyledLink = styled(Link)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    color: theme.colors?.dark,
}))

export default function TextLink(props: TextLinkProps) {
    const { size, to } = props

    const renderContent = () => {
        if (to) {
            return (
                <StyledLink to={to} onClick={props.onClick}>
                    {props.children}
                </StyledLink>
            )
        }
        return (
            <Box display="flex" alignItems="center" onClick={props.onClick}>
                {props.children}
            </Box>
        )
    }

    return (
        <Typography modifiers="block" size={size} component={props.component}>
            {renderContent()}
        </Typography>
    )
}
